import { useBaseInputStyles } from "../../forms/fields/baseInputStyles";
import { useCheckboxStyles } from "../../forms/fields/Checkbox";
import { Check } from "@mui/icons-material";
import { makeStyles } from "../../../providers/makeStyles";
import { OptionLabel } from "./OptionLabel";
import { OptionPrice } from "./OptionPrice";

const useStyles = makeStyles((theme, { disabled }) => ({
    main: {
        display: "flex",
        marginBottom: theme.spacing(1),
        WebkitTapHighlightColor: "rgba(0,0,0,0)"
    }
}));
export const OptionCheckbox = ({ id, checked, onChange, label, subLabel, disabled, price, discountPrice }) => {
    const classes = { ...useBaseInputStyles(), ...useStyles({ disabled }), ...useCheckboxStyles() };

    return (
        <label className={classes.main}>
            <div className={classes.wrapper}>
                <input
                    id={id}
                    className={`${classes.baseInput} ${classes.input}`}
                    type="checkbox"
                    checked={checked}
                    onChange={onChange}
                    disabled={disabled}
                />
                {checked && <Check className={classes.check}/>}
            </div>
            <OptionLabel label={label} subLabel={subLabel} />
            <OptionPrice price={price} discountPrice={discountPrice} />
        </label>
    );
};
